import en from './locales/en.json';
import cs from './locales/cs.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
// import other languages as needed

const translations = { en, cs, de, es, fr };

export function t(key, lang = 'en') {
  const keys = key.split('.');
  let value = translations[lang] || translations['en'];
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) break;
  }
  return value || key;
}